import clsx from 'clsx'
import React from 'react'

import {Typographyv2 as Typography} from '../../v2/typography'
import {classes} from './Badge.classes'
import {getTypographyProps} from './Badge.utils'
import {Props} from './types'

// wip компонент сделан не до конца, а только для случая <Badge size="s" variant="important" />
// todo дописать компонент https://www.figma.com/file/wLzOt0Aq3w3C67DqpqDVUp/2-%C2%B7-UI?node-id=34%3A1254
//      и добавить в сторибук
const Badge: React.FC<React.PropsWithChildren<Props>> = props => {
  const {children, variant = 'default', display = 'inline-flex'} = props
  const typographyProps = getTypographyProps(props)

  return (
    <Typography display={display} {...typographyProps} className={clsx(classes.root, classes[`variant_${variant}`])}>
      {children}
    </Typography>
  )
}

export default Badge
